import { Alert, Box, Typography } from '@mui/material';
import type { AlertItem } from '@azoupvendas/shared';

// AIDEV-NOTE: Lista de alertas color-coded por tipo
interface AlertCardProps {
  alertas: AlertItem[];
}

function getAlertSeverity(tipo: AlertItem['tipo']): 'error' | 'warning' | 'info' {
  switch (tipo) {
    case 'erro_sync':
      return 'error';
    case 'visita_atrasada':
    case 'meta_baixa':
      return 'warning';
    case 'lead_estagnado':
      return 'info';
    default:
      return 'info';
  }
}

export function AlertCard({ alertas }: AlertCardProps) {
  if (alertas.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
        Nenhum alerta no momento.
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {alertas.map((alerta, index) => (
        <Alert
          key={`${alerta.tipo}-${alerta.entidadeId}-${index}`}
          severity={getAlertSeverity(alerta.tipo)}
        >
          {alerta.mensagem}
        </Alert>
      ))}
    </Box>
  );
}
